import React from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {BcaEditIcon} from "../../../../../images/BcaIcon";
import BcaIconButton from "../../../../../components/Buttons/BcaIconButton/BcaIconButton";
import {Grid} from "@material-ui/core";

import PrimaryButton from "../../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../../components/BaseDialog/BaseDialog";
import InputFormElement from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {isValidString} from "../../../../../utils/utils";
import {parseResponse, PortfolioHandlerResource} from "../../../../../utils/api";
import {displayErrorSnackBar} from "../../../../../components/SnackbarProvider/actions";
import {SERVER_ERROR} from "../../../../../utils/constants";


const MusterDepotEditButton = (props) => {
  const {portfolio, dispatch, onUpdate} = props;

  const [modelPortfolioName, setModelPortfolioName] = React.useState(portfolio.name);
  const [open, setOpen] = React.useState(false);
  const [saveInProgress, setSaveInProgress] = React.useState(false);

  const handleClose = () => setOpen(false);

  const handleError = () => dispatch(displayErrorSnackBar(SERVER_ERROR));

  const handleSave = () => {
    setSaveInProgress(true);

    PortfolioHandlerResource.updatePortfolio(props.match.params.customer_id, portfolio.id, {
      name: modelPortfolioName
    })
    .then((response) => {
      parseResponse(response, 'portfolio', () => {
        setOpen(false);
        onUpdate && onUpdate();
      }, handleError)
    })
    .catch(handleError)
    .finally(() => setSaveInProgress(false))
  };

  return (
    <>
      <BcaIconButton
        tooltip={"Musterdepot umbenennen"}
        icon={<BcaEditIcon />}
        onClick={() => setOpen(true)}
      />
      <BaseDialog
        open={open}
        title={'Musterdepotname  ändern'}
        modalLoading={saveInProgress}
        maxWidth={'md'}
        actions={
          <Grid container justify={"flex-end"} spacing={2}>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text="Abbrechen"
                variant="outlined"
                onButtonClick={handleClose}
              />
            </Grid>
            <Grid item xs={12} sm={'auto'}>
              <PrimaryButton
                text={"Speichern"}
                onButtonClick={handleSave}
                disabled={!isValidString(modelPortfolioName)}
              />
            </Grid>
          </Grid>
        }
      >
        <Grid container spacing={2}>
          <Grid item sm={8} xs={12}>
            <InputFormElement
              value={modelPortfolioName}
              onChange={(val) => setModelPortfolioName(val)}
              fullWidth
              required
              label="Name"
              placeholder="Bitte geben Sie einen Namen für das Musterdepot ein"
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <CalendarFormElement
              required
              label="Startdatum"
              value={portfolio.tracking_start_date}
              disabled
            />
          </Grid>
        </Grid>
      </BaseDialog>
    </>
  )
};

export default withRouter(connect()(MusterDepotEditButton));